import {
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    format,
    isThisWeek,
    isYesterday,
} from 'date-fns';

/**
   * Formats a notification date based on how old it is
   *
   * @param date - The date to format (can be Date object or date string)
   * @returns Formatted date string based on age:
   * - Within 5 minutes: "Just Now"
   * - Within 24 hours: "<hours> ago"
   * - Yesterday: "Yesterday"
   * - Within last 7 days: Day of the week
   * - Older than 7 days: "MMM d, yyyy" format
   */
  export const formatNotificationDate = (date) => {
    const notificationDate = new Date(date);
    const now = new Date();
  
    // Within 5 minutes
    const minutesDiff = differenceInMinutes(now, notificationDate);
    if (minutesDiff < 5) {
      return 'Just Now';
    }
  
    // Within 24 hours
    const hoursDiff = differenceInHours(now, notificationDate);
    if (hoursDiff < 24) {
      return `${hoursDiff} ago`;
    }
  
    // Yesterday
    if (isYesterday(notificationDate)) {
      return 'Yesterday';
    }
  
    // Within last 7 days
    const daysDiff = differenceInDays(now, notificationDate);
    if (daysDiff < 7) {
      return format(notificationDate, 'EEEE'); // Full day name (Monday, Tuesday, etc.)
    }
  
    // Older than 7 days
    return format(notificationDate, 'MMM d, yyyy');
  };
  